import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Subscription} from 'rxjs/Subscription';
import {Router} from '@angular/router';
import {UrlConfig} from 'config/urlConfig';
import {NetworkService} from 'services/network.service';
import {SpinnerService} from 'services/spinner.service';
import { Console } from 'console';

@Component({
    selector: 'tpc-site-default',
    templateUrl: './site-default.component.html',
    styleUrls: ['./site-default.component.css'],
})
export class SiteDefaultComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    public isZipValid = true;
    public form: FormGroup;
    public countryList = [];
    public stateList = [];
    public isShown:boolean = true;
    public zipShown:boolean = true;

    constructor(private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private router: Router,
                private networkService: NetworkService,
                private spinner: SpinnerService) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            this.isZipValid = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        //this.createForm();
    }

    ngOnInit() {
        this.getCountryList();
        this.createForm();
    }

    private getCountryList(): void {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), { }).subscribe(
        country => {
                this.countryList = country;
                this.spinner.hide();
            }
        );
    }

    public getStateList(state) {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), {Country: 'US', CountryID: state}).subscribe(
            states => {
                this.stateList = states.sort((a, b) => a.StateAB.localeCompare(b.StateAB));
                if(this.stateList.length > 0)
                {
                    
                    if(this.stateList.length > 50)
                        this.zipShown = true;
                    else
                        this.zipShown = false;

                    this.isShown = true;
                    if(this.stateValidator.length == 3)
                        this.stateValidator = this.stateValidator.concat([Validators.required]);
                    this.form.updateValueAndValidity();
                }
                else
                {
                    this.isShown = false;
                    this.zipShown = false;
                    if(this.stateValidator.length == 4)
                        this.stateValidator.splice(this.stateValidator.length - 1,this.stateValidator.length);
                    this.form.get('state').setValidators(this.stateValidator);
                }
                this.spinner.hide();
            }
        );
    }

    private createForm() {
        this.form = this.fb.group({
            country: ['',  [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
            zip: ['', [
                Validators.minLength(3),
                Validators.maxLength(13),
                Validators.pattern(/^[A-Za-z0-9\-\s]+$/i)]],
            state: ['', this.stateValidator],
        });
    }

    private stateValidator = [
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)
    ];

    private next() {
        let countryid = this.form.get('country').value;
        let subregion = (this.form.get('state').value.length > 0)? this.form.get('state').value : 'na';
        let zip = (this.form.get('zip').value.length > 0)? this.form.get('zip').value : '0000',
            prop = {'ZIP': zip};

        
        if (this.stateList.length>0)
        {
            if (zip == '0000' && this.stateList.length>50) {
                this.isZipValid = false;
                return;
            }
            else if(this.form.get('state').value.length=='0')
            {
                this.isZipValid = false;
                return;
            }
            else {
                this.router.navigate(['/business/site/add'], {
                    queryParams: {zip: zip, subregion: subregion, countryid: countryid}
                });
            }
        }

        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('verifyZipCode'), prop).subscribe(
            response => {
                let isZipValid = response.length;
                this.spinner.hide();

                if (!isZipValid && this.stateList.length>0) {
                    this.isZipValid = false;
 
                    return;
                }

                this.router.navigate(['/business/site/add'], {
                    queryParams: {zip: zip, subregion: subregion, countryid: countryid}
                });
            }
        );
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/site/site-default/site-default.component.ts